import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const AppTree = (
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(AppTree);

